import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavService } from '../services/nav.service';
import { AuthService } from '../auth/auth.service';
import { TranslatorService } from '../services/translate.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss']
})
export class CreditsComponent implements OnInit {
  ss:any;
  user:any;
  sended: boolean = false;
  certurl: SafeResourceUrl;
  title = "Crediti";
  subTitle = "EDAC - Crediti";
  innerHeight:any;

  sedeId: any;
  societaId: any;
  fatturaId:any;
  numeroDocumento:any;
  codicePratica:any;

  constructor(
    public navService: NavService, 
    public translate: TranslatorService, 
    public authService: AuthService,
    private route: ActivatedRoute,
  ) { }


  ngDoCheck() {

    if (this.sended == false) {
      var frame: HTMLIFrameElement = document.getElementById('CreditsIframe') as HTMLIFrameElement;
      if (frame != null) {
        this.sended = true;
        frame.contentWindow?.postMessage('sstorage', this.ss);

        this.certurl = this.getUrl();
      }
    }

  }

  getUrl(){
    let url = environment.rootInvoiceCrediti + this.user.sub;

    if(this.sedeId) url += "&sedeId=" + this.sedeId;
    if(this.societaId) url += "&societaId=" + this.societaId;
    if(this.fatturaId) url += "&fatturaId=" + this.fatturaId;
    if(this.numeroDocumento) url += "&numeroDocumento=" + this.numeroDocumento;
    if(this.codicePratica) url += "&codicePratica=" + this.codicePratica;

    return url
  }

  loadLabels(){
    this.translate.get('LABEL.CREDITS').subscribe(res => {
      this.title = res;
      this.subTitle = "EDAC - " + res;
    })
  }

  ngOnInit(): void {
    this.ss = window.sessionStorage;
    this.user = this.authService.user();
    console.log('send message to iframe %o',this.ss);
    this.loadLabels();
    this.navService.setTitle(this.title);
    this.navService.setSubTitle(this.subTitle);
this.navService.setWikiKey('NODEF');
    let actions : any;
    actions = [
      {name:'export',url:''},
    ];
    this.getQueryParams()
    this.navService.setActions(actions);
    this.innerHeight = (window.innerHeight - 74) + 'px';
  }

  getQueryParams() {
    this.route.queryParamMap.subscribe(params => {
      const sedeId = params.get('sedeId');
      const societaId = params.get('societaId');
      const fatturaId = params.get('fatturaId');
      const numeroDocumento = params.get('numeroDocumento');
      const codicePratica = params.get('codicePratica');

      if(sedeId) this.sedeId = sedeId;
      if(societaId) this.societaId = societaId;
      if(fatturaId) this.fatturaId = fatturaId;
      if(numeroDocumento) this.numeroDocumento = numeroDocumento;
      if(codicePratica) this.codicePratica = codicePratica;

    });
  }

}